var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-c"},[_c('div',{staticClass:"line-title"},[_vm._t("title",function(){return [_c('span',{staticClass:"active",style:({color: _vm.activeColor})},[_vm._v("会员")]),_vm._v("线路系统\n        ")]})],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b149c48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/line/components/line-conponent/index.vue
// module id = null
// module chunks = 